import { env } from '../../env';

export const getAppVersion = () => {
  if (window.electron?.getAppVersionSync) {
    return window.electron?.getAppVersionSync();
  }

  return env.REACT_APP_VERSION;
};
